import {GENERATIONS, ZERO, ONE} from "./constants";
import {runGen2RecoverFlow} from "../flows/recover-flow/recover-gen2";

const FETCH_AMOUNT = 40;
const VIRTUALIZED_TAB_REFRESH_TIMER = 5000;
const VIRTUALIZED_TAB_SORT_COL = 0;

class deviceList {

  isInventoryPage() {
    return true;
  }

  getDeviceSummaryBaseUrl() {
    return '/device/device_summary/';
  }

  showIfAllowed(popout, action) {
    const entity = 'device_';
    const permissionToCheck = this.pageData.permissions['can_' + action];
    if (permissionToCheck) {
      popout.find('.' + entity + action).show();
    }
  }

  withPrefix(selector) {
    const pageId = this.pageData.pageId;
    const selectors = selector.split(',').map(item => '#' + pageId + ' ' + item);
    return selectors.join(',');
  }

  setClickHandlers() {
    const self = this;

    $(this.withPrefix('#template_popout_deviceinventory, #template_popout_deviceinventory_virt, #template_popout_deviceinventory_vault_virt')).find('.popoutitem.device_details').data('clickHandler', e => {
      const id = $(e.currentTarget).closest('.trow').data('id');
      self.deviceDetailsHandler(id);
      e.stopPropagation();
    });

    $(this.withPrefix('#template_popout_deviceinventory .popoutitem.device_recover')).data('clickHandler', e => {
      const $row = $(e.currentTarget).closest('.trow');
      const service_gen = parseInt($row.data().service_gen);
      if (service_gen === GENERATIONS.BRC) {
        runGen2RecoverFlow(
          {deviceId: $row.data('id'), clientId: this.pageData.clientId, startStep: 'locateVirtualization'});
      } else {
        runGen4RecoverFlow(
          {deviceId: $row.data('id'), clientId: this.pageData.clientId, resellerId: this.pageData.resellerId, startStep: 'typeRB'});
      }
      e.stopPropagation();
    });
  }

  init(pageData) {
    this.pageData = pageData;
    const self = this;

    $(this.withPrefix('.axCarousel')).axCarousel({
      axDataLocation: () => {
        return self.getItemsUrl();
      },
      startTab: self.pageData.startTab,
      onFetch: (e, fetched) => {
        if (self.isInventoryPage() && fetched.clientHealthLastCheck && (fetched.clientHealthLastCheck !== self.pageData.clientHealthLastCheck) && !self.pageData.vaultId) {
          self.inventoryReload();
        } else {
          if (fetched.typeCounters !== undefined) {
            $(self.withPrefix('.axCarousel')).find('.header-tab .badge').addClass('zero').text('');
            for (const type in fetched.typeCounters) {
              const $tab = $(self.withPrefix('.axCarousel')).find(`.header-tab[data-type=${type}]`);
              $tab.find('.badge').removeClass('zero').text(fetched.typeCounters[type]);
            }
          }
          if (fetched.showVirtualized && pageData.pageKey === 'devices-tab') {
            $(self.withPrefix('.axCarousel')).find('.header-tab[data-type="VIRTUALIZED"]').show();
             $(this.withPrefix('.axCarousel')).axCarousel('forceArrowReinit');
          } else if(pageData.pageKey === 'devices-tab') {
            $(self.withPrefix('.axCarousel')).find('.header-tab[data-type="VIRTUALIZED"]').hide();
            $(this.withPrefix('.axCarousel')).axCarousel('forceArrowReinit');
          }
          if (pageData.pageKey === 'devices-tab') {
            const $vaultVirtualized = $(self.withPrefix('.axCarousel')).find('.header-tab[data-type="VAULT_VIRTUALIZED"]');
            if (fetched.showVaultVirtualized) {
              $vaultVirtualized.show();
            } else {
              $vaultVirtualized.hide();
            }
            $(this.withPrefix('.axCarousel')).axCarousel('forceArrowReinit');
          }
        }
      },
      axTableOptions: {
        type: 'device',
        defaultView: 'axTableList',
        fetchOnScroll: true,
        views: {
          axTableList: {
            sorting: true,
            actionCol: self.isInventoryPage(),
            fetchAmount: FETCH_AMOUNT,
            popoutTemplate: 'template_popout_deviceinventory',
            detailsHandler: e => {
              if (!self.pageData.vaultId) {
                tabs_goto('/device/details/' + $(e.currentTarget).parents('.trow').data('id'), 'li.clients-tab');
              } else {
                tabs_goto('/device/details/' + $(e.currentTarget).parents('.trow').data('id') + '/' + self.pageData.vaultId, 'li.clients-tab');
              }
              e.stopPropagation();
            },
            summaryHandler: {
              data: self.pageData.vaultId ? self.getDeviceSummaryBaseUrl() + `0/${self.pageData.vaultId}` : self.getDeviceSummaryBaseUrl(),
              template: 'axtable-machine'
            },
						isSummaryCanBeOpened: row => row.data('client_id'),
            noDataHandler: {
              data: () => {
                const $selected = $(self.withPrefix('.header-tab.selected'));
                return {
                  type: $selected.data('type'),
                  isInventory: self.isInventoryPage(),
                  'has_machines': $selected.data('num-items'),
                  'client_id': self.pageData.clientId,
                  'is_client': self.pageData.is_client,
                  vaultId: self.pageData.vaultId,
                  clientId: self.pageData.clientId,
                  isReplibit: self.pageData.vaultId || self.pageData.hasGen4 || self.pageData.clientImportedId,
                  hasDevices: self.pageData.hasDevices
                };
              },
              template: 'axtable-deviceinventory-empty',
              hideHeader: true,
              noContainer: true
            },
            onFetchHandler: () => {
              $(self.withPrefix('.action_cell')).on('click', e => {
                const $row = $(e.currentTarget).parent();
                const $popout = $(self.withPrefix('.popout'));
                $popout.find('div').hide();
                const hasApp = $row.data('has_appliance');
                const vaultOnlyNonD2CDevice = $row.data('vault_only_device');
                if (self.pageData.vaultId) {
                  if (hasApp === '1' || vaultOnlyNonD2CDevice === '1') { // Hide details action for D2C device
                    self.showIfAllowed($popout, 'details');
                    self.showIfAllowed($popout, 'recover');
                  }
                } else {
                  self.showIfAllowed($popout, 'details');
                  self.showIfAllowed($popout, 'recover');
                }
              });
            }
          }
        }
      },
      tabs: {
        '[data-type="VIRTUALIZED"]': {
          autoRefresh: VIRTUALIZED_TAB_REFRESH_TIMER,
          fetchOnScroll: true,
          fetchOnInit: true,
          views: {
            axTableList: {
              clientSideSorting: true,
              sortCol: VIRTUALIZED_TAB_SORT_COL,
              fetchAmount: FETCH_AMOUNT,
              popoutTemplate: 'template_popout_deviceinventory_virt',
              summaryHandler: {
                data: '/device/device_summary/1',
                template: 'axtable-virtualized'
              },
              isSummaryCanBeOpened: row =>  {
                if (row.data('service_gen') == GENERATIONS.REPLIBIT) {
                  return row.data('currently_running');
                } else if (row.data('service_gen') == GENERATIONS.BRC) {
                  return true;
                } else {
                  return false;
                }
              },
              noDataHandler: {
                data: () => {
                  const $selected = $(self.withPrefix('.header-tab.selected'));
                  return {
                    type: $selected.data('type'),
                    'has_machines': $(self.withPrefix('[data-type="PROTECTED"]')).data('num-items')
                  };
                }
              },
              onFetchHandler: () => {
                const num = $(self.withPrefix('.trow[data-sva_job_status!="Offline"][data-appliance_online="1"]')).length;
                let classes = 'badge badge-grey virtualized digits' + (num + '').length;
                if (!num) {
                  classes += ' zero';
                }
                // refresh header active VMs count
                $(self.withPrefix('.header-tab[data-type="VIRTUALIZED"] .badge')).text(num).attr('class', classes);

                $(self.withPrefix('.trow[data-appliance_online] .action_cell')).on('click', e => {
                  const $row = $(e.currentTarget).parent();
                  const $popout = $(self.withPrefix('.trow[data-appliance_online] .popout'));
                  $popout.find('div').hide();
                  if ($row.data('service_gen') == GENERATIONS.REPLIBIT) {
                    self.showIfAllowed($popout, 'details');
                    return;
                  }
                  if ($row.data('appliance_online') === ZERO) {
                    self.showIfAllowed($popout, 'details');
                  } else if ($row.data('sva_job_status') === 'Offline') {
                    self.showIfAllowed($popout, 'details');
                    self.showIfAllowed($popout, 'start_vm');
                  } else if ($row.data('sva_job_status') === 'Running') {
                    self.showIfAllowed($popout, 'details');
                    self.showIfAllowed($popout, 'discard_vm');
                    if ($row.data('stoppable')) {
                      self.showIfAllowed($popout, 'stop_vm');
                    }
                  } else if ($row.data('sva_job_status') === 'Stopped') {
                    self.showIfAllowed($popout, 'details');
                    self.showIfAllowed($popout, 'resume_vm');
                    self.showIfAllowed($popout, 'discard_vm');
                  } else {
                    self.showIfAllowed($popout, 'details');
                  }
                });
              }
            }
          }
        },
        '[data-type="VAULT_VIRTUALIZED"]': {
          autoRefresh: VIRTUALIZED_TAB_REFRESH_TIMER,
          fetchOnScroll: true,
          fetchOnInit: true,
          views: {
            axTableList: {
              clientSideSorting: true,
              sortCol: VIRTUALIZED_TAB_SORT_COL,
              fetchAmount: FETCH_AMOUNT,
              popoutTemplate: 'template_popout_deviceinventory_vault_virt',
              summaryHandler: {
                data: '/device/vault_virtualized_device_summary',
                template: 'axtable-vault-virtualized'
              },
              isSummaryCanBeOpened: row => row.data('currently_running'),
              noDataHandler: {
                data: () => {
                  const $selected = $(self.withPrefix('.header-tab.selected'));
                  return {
                    type: $selected.data('type'),
                    has_machines: $(self.withPrefix('[data-type="VAULT_VIRTUALIZED"]')).data('num-items')
                  };
                }
              },
              onFetchHandler: () => {
                const num = $(self.withPrefix('.trow[data-currently_running="true"]')).length;
                let classes = 'badge badge-grey vault-virtualized digits' + (num + '').length;
                if (!num) {
                  classes += ' zero';
                }
                // refresh header active VMs count
                $(self.withPrefix('.header-tab[data-type="VAULT_VIRTUALIZED"] .badge')).text(num).attr('class', classes);

                $(self.withPrefix('.action_cell')).on('click', e => {
                  const $popout = $(self.withPrefix('.trow[data-currently_running] .popout'));
                  $(self.withPrefix('.popout')).find('div').hide();
                  self.showIfAllowed($popout, 'details');
                });
              }
            }
          }
        },
      }
    });

    this.setClickHandlers();
  }
}

export {deviceList};
